import * as TabsPrimitive from "@radix-ui/react-tabs";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren;

/**
 * タブのトリガーを取りまとめるコンポーネント
 * @param props props
 * @returns タブのトリガーを取りまとめるコンポーネント
 */
export default function TabsList(props: Props) {
	const { children } = props;

	return <TabsPrimitive.List>{children}</TabsPrimitive.List>;
}
